module.exports = __webpack_public_path__ + "img/NBL1 Uniforms.575073fe.png";